/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import ReactMarkdown from 'react-markdown';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Grid from '@material-ui/core/Grid';
import {
    object, number, string, func, shape, arrayOf, bool, array,
} from 'prop-types';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { bindActionCreators } from 'redux';
import  StatusTracking from '../../common/StatusTracking';
import { dateMMMMDDYYYY } from '../../utils/dateString';
import GraphqlPortalLoader from '../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlPortalLoader';
import {
    getOrderId,
} from '../../../../../state/ducks/Common/Common-Selectors';
import configENV from '../../config';
import { isEmpty } from '../../utils/object';
import { secureProtocol } from '../../utils/secureProtocol';
import getSiteConfig from '../../utils/getSiteConfig';
import { fetchAllOrderDetails } from '../../../../../state/ducks/Order/Order-Actions';
import { trackEvent as track } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import brandNames from '../../assets/data/BrandNames';
import Helper from '../../state/reducers/Helper';

const {
    PERSIST_KEY,
    FEDEX_ORDERTRACKING_URL,
    UPS_ORDERTRACKING_URL,
    USPS_ORDERTRACKING_URL,
    UDS_ORDERTRACKING_URL,
} = configENV;

class DesktopOrderListItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
        };
    }

    handleBuyAgainClicked = (
        orderNumber, buyAllItems, ROSSItem,
    ) => {
        const {
            setAllPlaced, history, trackEvent,
        } = this.props;
        const data = {
            orderNumber, history,
        };
        if (!buyAllItems) {
            /**
             * if not buy all items, get the intOrderNumber from item and pass to request object
             * the setAllPlaced will get the item from orderDetails with given intOrderNumber
             * else buy all items in order
             */
            data.intOrderNumber = ROSSItem?.intOrderNumber;
        }
        this.setState({ loader: true });
        trackEvent({
            eventCategory: 'Orders',
            eventLabel: ROSSItem?.productName,
            eventAction: 'Buy Again',
        });

        setAllPlaced(data);
    }

    subscriptionInterval = (i) => {
        const SUBSCRIPTION_INTERVALS = {
            1: 'Delivers every 1 week',
            2: 'Delivers every 2 weeks',
            4: 'Delivers every 4 weeks',
            6: 'Delivers every 6 weeks',
            8: 'Delivers every 8 weeks',
            30: 'Delivers monthly',
        };
        return SUBSCRIPTION_INTERVALS[i] ? SUBSCRIPTION_INTERVALS[i] : i;
    }

    renderTrackingLink = (carrier, trackingNumber, deliveryLink = '') => {
        let carrierUrl;
        switch (carrier) {
            case 'FEDEX':
                carrierUrl = FEDEX_ORDERTRACKING_URL;
                break;
            case 'UPS':
                carrierUrl = UPS_ORDERTRACKING_URL;
                break;
            case 'USPS':
            case 'MAIL':
                carrierUrl = USPS_ORDERTRACKING_URL;
                break;
            case 'UDS':
                carrierUrl = UDS_ORDERTRACKING_URL;
                break;
            default:
                carrierUrl = null;
        }
        if (!deliveryLink) {
            return carrierUrl ? (
                <a
                    href={carrierUrl + trackingNumber}
                    target="_blank"
                    rel="noreferrer"
                    className="link"
                >
                    {trackingNumber}
                </a>
            ) : (
                <span>{trackingNumber}</span>
            );
        }
        return (
            <a
                href={deliveryLink}
                target="_blank"
                rel="noreferrer"
                className="link"
            >
                {trackingNumber}
            </a>
        );
    }

    showCarrier = (ROSSCarrier) => {
        if (ROSSCarrier === 'FEDEX') {
            return <img alt="fedex logo" src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blt986d6df1eca50df5/5f9715bf545bdb56ce4903e6/fedex-logo.svg" />;
        }
        if (ROSSCarrier === 'UDS') {
            return <img alt="uds logo" src="https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltc6883e40544a7af1/6165e3b4a481550b84bdc2eb/UDS_logo_1.svg" />;
        }
        return <span className="bold">{ROSSCarrier}</span>;
    }

    showBuyAgainButton = (item) => {
        const { isBuyAgainEnabled } = this.props;
        const allowedProductTypes = ['SUB'];
        if (isBuyAgainEnabled && (item.addonType === '' || allowedProductTypes.includes(item.addonType))) {
            return true;
        }

        return false;
    }

    showSubStatus = (ROSSItem = {}) => {
        const {
            statusDescription, history, type, deliveryLink,
        } = ROSSItem;
        if (type === 'FPT') {
            const isOrderDelayed = history.length > 0 && history[0].attemptedReason;
            if (isOrderDelayed) {
                const deliveryDescription = statusDescription || history[0].statusDescription;
                return (
                    <div className="delay-container">
                        <img src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blte21ce9e1faee603c/6042a5473c41f30bce48321a/Warning_Icon.svg" alt="warning" />
                        <b>{deliveryDescription}</b>
                    </div>
                );
            }
            return <b>{statusDescription}</b>;
        }

        if (type === 'GPT') {
            const isOrderDelayed = history.length > 0 && history[0].codeStatus === 'DE';
            if (isOrderDelayed) {
                const deliveryDescription = statusDescription || history[0].statusDescription;
                return (
                    <div className="delay-container">
                        <img src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blte21ce9e1faee603c/6042a5473c41f30bce48321a/Warning_Icon.svg" alt="warning" />
                        { deliveryLink  ? (
                            <a
                                href={deliveryLink}
                                target="_blank"
                                rel="noreferrer"
                                className="link"
                            >
                                {deliveryDescription}
                            </a>
                        ) : <b>{deliveryDescription}</b> }
                    </div>
                );
            }
            return deliveryLink ? (
                <a
                    href={deliveryLink}
                    target="_blank"
                    rel="noreferrer"
                    className="link"
                >
                    {statusDescription}
                </a>
            ) : <b>{statusDescription}</b>;
        }
        return statusDescription ? (
            <b>{statusDescription}</b>
        ) : null;
    }

    render() {
        const {
            items, index, brandID,
            orderNumber, userProfile,
            ROSSOrder, addToCartError, isROSSUIEnabled, ROSSItem, featureFlags,
        } = this.props;

        if (!userProfile) {
            return null;
        }
        let id; let recpFirstName; let recipientLastName; let recipientFirstName; let recpLastName; let status; let paymentStatus; let carrier; let trackingNumber;
        let productBrand; let subscriptionType; let estimatedDeliveryDate; let arrivalEndDate; let itemDetailList; let prdImgCtg; let productName; let itemType; let productSku; let seoUrl;
        let interval;

        if (!isEmpty(items)) {
            ({
                id, recpFirstName, recipientLastName, recipientFirstName, recpLastName, status, paymentStatus, carrier, trackingNumber,
                productBrand, subscriptionType, estimatedDeliveryDate, arrivalEndDate, itemDetailList, interval, prdImgCtg, productName, itemType, productSku, seoUrl,
            } = items);
        }
        // There is a discrepancy of Order Details' API response between login and guest account.

        const estDeliveryDate = estimatedDeliveryDate || arrivalEndDate;
        const deliveryDate = dateMMMMDDYYYY(estDeliveryDate);
        const passPortLogo = 'https://images.contentstack.io/v3/assets/blt95e0138311135214/bltd8ac364c488b6313/5fd24cc550460c30dd5404bc/passport-logo.jpg';
        if (!isEmpty(itemDetailList)) {
            ([{
                prdImgCtg, itemType, productSku, productName, seoUrl,
            }] = itemDetailList);
        }
        const fallbackImgURL = 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltc881f4b32ef5f484/60dcd2de4b10c259bbae6426/Image_Not_Available.png';
        const productImageURL = prdImgCtg && prdImgCtg !== '' ? secureProtocol(prdImgCtg) : prdImgCtg;
        const { loader } = this.state;
        const passportRegex = /(passport annual membership|passport for|passport at)/gi;
        const passportImgRegex = /ppcarticoncelebrationspassportlogoc.jpg/gi;
        const isPassport = subscriptionType === 'Passport' || productName?.match(passportRegex)?.length > 0 || productImageURL?.match(passportImgRegex);
        const ROSSProductImageURL = ROSSItem?.prdImgCtg && ROSSItem?.prdImgCtg !== '' ? secureProtocol(ROSSItem?.prdImgCtg) : fallbackImgURL;
        const ROSSDeliveryDate = ROSSItem.estimatedDeliveryDate ? dateMMMMDDYYYY(ROSSItem.estimatedDeliveryDate) : dateMMMMDDYYYY(ROSSItem.deliveryDate);
        const ROSSFlexDeliveryDate = ROSSItem.flexDate ? dateMMMMDDYYYY(ROSSItem.flexDate) : '';
        const isROSSPassportItem = ROSSItem?.subscriptionType === 'Passport' || ROSSItem?.productName?.match(passportRegex)?.length > 0;
        const isDonationItem = Helper.checkIsDonationItem(ROSSItem?.productName);
        const ROSSDeliveryStatus = ROSSItem?.status;
        const ROSSOrderPendingCancel = ROSSOrder?.pendingCancel;
        const IsPendingCancelEnabled = featureFlags?.['is-pending-cancel-enabled'];
        const ROSSRecipientName = `${ROSSItem.recpFirstName} ${ROSSItem.recpLastName}`;
        const recipientCompanyName = ROSSItem?.businessName ? ROSSItem.businessName : '';
        const isCYOColChild = ROSSItem?.addonType === 'CYO' || ROSSItem?.addonType === 'COLLECTION';
        const showDelivered = isROSSPassportItem || isDonationItem;

        const isSameLogicalOrder = ROSSOrder?.intOrderNumber === ROSSItem?.intOrderNumber;
        return !isEmpty(ROSSOrder) && isROSSUIEnabled ? (
            <React.Fragment key={id}>
                <Grid container className={!isCYOColChild ? 'orderItemGrid' : ''}>
                    {index === 0 || !isSameLogicalOrder ? (
                        <Grid className="productInnerDiv" item xs={3}>
                            <div>
                                <div className="bold">
                                    {ROSSRecipientName}
                                </div>
                                <div className="brandName">
                                    {recipientCompanyName}
                                </div>
                            </div>
                        </Grid>
                    )
                        : (
                            <>
                                {isCYOColChild ? (
                                    null
                                )
                                    : (
                                        <Grid className="productInnerDiv" item xs={3} />
                                    )}
                            </>
                        )}
                    {!isCYOColChild && (
                        <>
                            <Grid className="orderStatusInfo" item xs={5}>
                                {(index === 0 || !isSameLogicalOrder) && (
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <StatusTracking
                                                ROSSStatus={showDelivered ? 'DELIVERED' : ROSSDeliveryStatus}
                                                isROSSUIEnabled={isROSSUIEnabled}
                                                ROSSOrderPendingCancel={ROSSOrderPendingCancel}
                                                IsPendingCancelEnabled={IsPendingCancelEnabled}

                                            />
                                        </Grid>
                                        <Grid className="subStatusContainer" item xs={8}>
                                            {this.showSubStatus(ROSSItem?.orderStatusAttributes || ROSSOrder)}
                                        </Grid>
                                        {/* Display order status information if it's not the cancelled, pending cancel and donation item */}
                                        {ROSSDeliveryStatus !== 'CANCELLED' && !ROSSOrderPendingCancel && !isDonationItem
                                            ? (
                                                <>
                                                    {isROSSPassportItem
                                                        ? (
                                                            <Grid className="orderDetail" item xs={12}>
                                                                <div className="gray-color uppercase">Membership Start Date: </div>
                                                                <span className="bold">{ROSSDeliveryDate}</span>
                                                            </Grid>
                                                        ) : (
                                                            <>
                                                                {ROSSFlexDeliveryDate || ROSSDeliveryDate
                                                                    ? (
                                                                        <Grid className="orderDetail" item xs={12}>
                                                                            <span className="gray-color uppercase">{brandID === 'HD' ? 'Delivery Date / Arrives: ' : 'Requested Date: '}</span>
                                                                            <span className="bold">{ROSSFlexDeliveryDate || ROSSDeliveryDate}</span>
                                                                        </Grid>
                                                                    ) : null}
                                                                {ROSSItem.itemType === 'FPT'
                                                                    ? (
                                                                        <>
                                                                            <Grid className="orderDetail" item xs={12}>
                                                                                <span className="gray-color uppercase">Delivered by: </span>
                                                                                <span className="bold">Local Shop</span>
                                                                            </Grid>
                                                                            {ROSSItem.dtwName
                                                                                ? (
                                                                                    <Grid className="orderDetail" item xs={12}>
                                                                                        <span className="gray-color uppercase">Requested time: </span>
                                                                                        <span className="bold">{ROSSItem.dtwName}</span>
                                                                                    </Grid>
                                                                                ) : null }
                                                                        </>
                                                                    ) : null}
                                                                {ROSSItem.itemType === 'GPT'
                                                                    ? (
                                                                        <>
                                                                            {ROSSItem?.carrier && (
                                                                                <Grid className="orderDetail display-flex" item xs={12}>
                                                                                    <span className="gray-color uppercase">Delivered by:&nbsp;&nbsp;</span>
                                                                                    {this.showCarrier(ROSSItem?.carrier)}
                                                                                </Grid>
                                                                            )}
                                                                            {(ROSSDeliveryStatus !== 'CANCELLED') && (
                                                                                <Grid className="orderDetail" item xs={12}>
                                                                                    <span className="gray-color uppercase">Tracking: </span>
                                                                                    <span className="bold">{ROSSItem?.trackingNumber
                                                                                        ? (
                                                                                            this.renderTrackingLink(ROSSItem?.carrier, ROSSItem?.trackingNumber, ROSSItem?.orderStatusAttributes?.deliveryLink)
                                                                                        ) : 'Available once shipped'}
                                                                                    </span>
                                                                                </Grid>
                                                                            )}
                                                                        </>
                                                                    ) : null}
                                                            </>
                                                        )}
                                                </>
                                            ) : null}
                                    </Grid>
                                )}
                            </Grid>
                            <Grid className="productInnerDiv" item xs={4}>
                                <div className="productImg">
                                    <img
                                        src={isROSSPassportItem ? passPortLogo : ROSSProductImageURL}
                                        alt={ROSSItem.productSku}
                                        onError={(e) => {
                                            if (e.target.src !== fallbackImgURL) {
                                                e.target.src = fallbackImgURL;
                                            }
                                        }}
                                    />
                                    <div className="productName">
                                        <div className="productLink">
                                            <Link to={ROSSItem.seoUrl || `/searchterm/${ROSSItem.productSku}`}>
                                                <span className="link">
                                                    <ReactMarkdown className="reactMarkdownLink" source={ROSSItem.productName} />
                                                </span>
                                            </Link>
                                        </div>
                                        <div className="productBrandName">
                                            <span>{brandNames[ROSSItem.productBrand]}</span>
                                        </div>
                                        <div className="productId">
                                            Item #:
                                            <span className="productIdValue">
                                                {ROSSItem.productSku}
                                            </span>
                                        </div>
                                        { this.showBuyAgainButton(ROSSItem) ? (
                                            <Button
                                                variant="contained"
                                                style={{ textTransform: 'none' }}
                                                className="buyAgain"
                                                onKeyDown={() => { }}
                                                onClick={() => this.handleBuyAgainClicked(orderNumber, false, ROSSItem)}
                                            >
                                                Buy Again
                                            </Button>
                                        ) : null}
                                        {ROSSItem.interval ? (
                                            <div className="subscription">
                                                <span className="subscriptionDelivery">{this.subscriptionInterval(ROSSItem.interval)}</span>
                                                <Link to="/account/subscriptions">Manage Subscriptions</Link>
                                            </div>
                                        ) : ''}
                                    </div>
                                </div>
                            </Grid>
                            {(loader && !addToCartError) && <GraphqlPortalLoader />}
                        </>
                    )}
                </Grid>
            </React.Fragment>
        ) : (
            <React.Fragment key={id}>
                <Grid container className="orderItemGrid">
                    <Grid className="productInnerDiv" item xs={3}>
                        {index === 0 ? (
                            <div>
                                <div className="bold">
                                    {recipientFirstName || recpFirstName} {recipientLastName || recpLastName  }
                                </div>
                                <div className="brandName">
                                    {productBrand}
                                </div>
                            </div>
                        )
                            : <span />}
                    </Grid>
                    <Grid className="orderStatusInfo" item xs={5}>
                        <Grid container>
                            <Grid item xs={12}>
                                <StatusTracking
                                    status={isPassport ? 'D' : status || paymentStatus}
                                />
                            </Grid>
                            {isPassport ? (
                                <Grid className="orderDetail" item xs={12}>
                                    <div className="gray-color uppercase">Membership Start Date: </div>
                                    <span className="bold">{deliveryDate}</span>
                                </Grid>
                            ) : (
                                <>
                                    {deliveryDate
                                        ? (
                                            <Grid className="orderDetail" item xs={12}>
                                                <span className="gray-color uppercase">{brandID === 'HD' ? 'Delivery Date / Arrives: ' : 'Requested Date: '}</span>
                                                <span className="bold">{deliveryDate}</span>
                                            </Grid>
                                        ) : null}
                                    {itemType === 'GPT' ? (
                                        <>
                                            {carrier && (
                                                <Grid className="orderDetail" container alignItems="center" item xs={12}>
                                                    <span className="gray-color uppercase">Delivered by: </span>
                                                    {carrier === 'FEDEX' || !carrier ? (
                                                        <img alt="fedex logo" className="fedex-logo" src="https://images.contentstack.io/v3/assets/blt95e0138311135214/blt986d6df1eca50df5/5f9715bf545bdb56ce4903e6/fedex-logo.svg" />
                                                    ) : <span className="bold">{carrier}</span>}
                                                </Grid>
                                            )}
                                            {(paymentStatus !== 'C') && (
                                                <Grid className="orderDetail" item xs={12}>
                                                    <span className="gray-color uppercase">Tracking: </span>
                                                    <span className="bold">{trackingNumber
                                                        ? (
                                                            this.renderTrackingLink(carrier, trackingNumber)
                                                        ) : 'Available Once Shipped'}
                                                    </span>
                                                </Grid>
                                            )}
                                        </>
                                    ) : null}
                                    {!carrier && itemType === 'FPT'
                                        ? (
                                            <Grid className="orderDetail" item xs={12}>
                                                <span className="gray-color uppercase">Delivered by: </span>
                                                <span className="bold">Local Shop</span>
                                            </Grid>
                                        ) : null}
                                </>
                            )}
                        </Grid>
                    </Grid>
                    <Grid className="productInnerDiv" item xs={4}>
                        <div className="productImg">
                            <img src={isPassport ? passPortLogo : productImageURL} alt={productSku} />
                            <div className="productName">
                                <div className="productLink">
                                    <Link to={seoUrl}>
                                        <span className="link">
                                            <ReactMarkdown source={productName} />
                                        </span>
                                    </Link>
                                </div>
                                { this.showBuyAgainButton(items)  ? (
                                    <div className="order-history-margin">
                                        <Button
                                            variant="contained"
                                            style={{ textTransform: 'none' }}
                                            className="buyAgain"
                                            onKeyDown={() => { }}
                                            onClick={() => this.handleBuyAgainClicked(orderNumber, false, items)}
                                        >
                                            Buy Again
                                        </Button>
                                    </div>
                                ) : null}
                                {interval ? (
                                    <div className="subscription">
                                        <span className="subscriptionDelivery">{this.subscriptionInterval(interval)}</span>
                                        <Link to="/account/subscriptions">Manage Subscriptions</Link>
                                    </div>
                                ) : ''}
                                <div className="productId">
                                    Item #:
                                    <span className="productIdValue">
                                        {productSku}
                                    </span>
                                </div>

                            </div>
                        </div>
                    </Grid>
                </Grid>
                {(loader && !addToCartError) && <GraphqlPortalLoader />}
            </React.Fragment>
        );
    }
}
DesktopOrderListItem.propTypes = {
    items: shape({
        brandId: string,
        productSku: string,
        productName: string,
        recpFirstName: string,
        recpLastName: string,
        shipDate: string,
        paymentStatus: string,
        estimatedDeliveryDate: string,
        trackingNumber: string,
        itemType: string,
        sfItemType: string,
        addonType: string,
        parentLineNumber: string,
        childLineNumber: string,
        flexDate: string,
        flexMessage: string,
        flexGuaranteedFlag: string,
        prdImgCtg: string,
        prdImgTmn: string,
        arrivalStartDate: string,
        arrivalEndDate: string,
        carrier: string,
        seoUrl: string,
        subscriptionType: string,
        interval: string,
        duration: string,
        modifyOrder: string,
        status: string,
        itemDetailList: arrayOf(
            shape({
                cardMessage: string,
                productName: string,
                productSku: string,
                productBrand: string,
                price: string,
                itemType: string,
                sfItemType: string,
                addonType: string,
                parentLineNumber: string,
                childLineNumber: string,
                prdImgCtg: string,
                prdImgTmn: string,
                seoUrl: string,
            }),
        ),
    }).isRequired,
    index: number.isRequired,
    orderNumber: string.isRequired,
    history: object,
    userProfile: shape({
        isAuthenticated: bool.isRequired,
    }).isRequired,
    ROSSOrder: shape({
        brandId: string,
        modifiedDateTime: string,
        orderNumber: string,
        modifyOrder: string,
        uuid: string,
        status: string,
        orders: arrayOf(
            shape({
                carrier: string,
                history: array,
                brandId: string,
                type: string,
                deliveryDate: string,
                modifiedDateTime: string,
                status: string,
                statusDescription: string,
                trackingNumber: string,
                warningMessage: string,
                items: arrayOf(
                    shape({
                        duration: string,
                        interval: string,
                        itemType: string,
                        prdImgCtg: string,
                        prdImgTmn: string,
                        productName: string,
                        productSku: string,
                        seoUrl: string,
                        subscriptionType: string,
                    }),
                ),
            }),
        ),
    }),
    ROSSItem: shape({
        duration: string,
        interval: string,
        itemType: string,
        prdImgCtg: string,
        prdImgTmn: string,
        productName: string,
        productSku: string,
        seoUrl: string,
        subscriptionType: string,
    }),
    featureFlags: object,
    // orderId: string.isRequired,
    // fetchBuyAgainOrderDetail: func.isRequired,
    isBuyAgainEnabled: bool.isRequired,
    addToCartError: string.isRequired,
    setAllPlaced: func.isRequired,
    trackEvent: func.isRequired,
    isROSSUIEnabled: bool.isRequired,
    brandID: string.isRequired,
};

DesktopOrderListItem.defaultProps = {
    history: {},
    ROSSOrder: {},
    ROSSItem: {},
    featureFlags: {},
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isAuthenticated: newState.isAuthenticated,
        orderId: getOrderId(state),
        featureFlags: getFeatureFlags(state),
        brandID: getSiteConfig('brand-id'),
    };
};

const mapDispatchToProps = (dispatch) => ({
    setAllPlaced: bindActionCreators(fetchAllOrderDetails, dispatch),
    trackEvent: bindActionCreators(track, dispatch),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(DesktopOrderListItem));
